module.exports = __webpack_public_path__ + "static/media/Building A-2-Meter_DB2A.5137b335.jpg";